import React, { ReactElement } from "react";
import { Modal as MUIModal } from "@mui/material";
import { Close } from "@mui/icons-material";
import Button from "../../atoms/Button/Button";
import { useTranslation } from "react-i18next";

interface ModalProps {
  open: boolean;
  title: string;
  children: ReactElement;
  footer?: ReactElement;
  isConfirmDisabled?: boolean;
  onClose: () => void;
  onConfirm?: () => void;
}

const Modal = (props: ModalProps) => {
  const {
    open,
    title,
    children,
    footer,
    isConfirmDisabled,
    onClose,
    onConfirm,
  } = props;

  const { t } = useTranslation();

  return (
    <MUIModal open={open} onClose={onClose} className="dui-modal">
      <div className="dui-modal-content">
        <div className="dui-modal-content-inner">
          <div className="dui-modal-title">
            {title} <Button icon={<Close />} type="text" onClick={onClose} />
          </div>
          {children}
        </div>
        <div className="dui-modal-footer">
          {footer ? (
            footer
          ) : (
            <>
              <Button type="text" onClick={onClose}>
                {t("cancel")}
              </Button>
              <Button onClick={onConfirm} disabled={isConfirmDisabled}>
                {t("confirm")}
              </Button>
            </>
          )}
        </div>
      </div>
    </MUIModal>
  );
};

export default Modal;
